import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { loadNationalities } from '~/AeMaxPrice/actions';
import { State as AeMaxPriceState } from '~/AeMaxPrice/reducer';
import { Country } from '~/Api/Country';
import Autocomplete, { Option } from '~/UI/Autocomplete/Autocomplete';

const mapOptions = memoizeOne((countries, query): Option[] => {
	return filterCountries(countries, query).map((country) => ({
		id: country.alpha2,
		title: country.name,
	}));
});

function filterCountries(countries: Country[], query: string): Country[] {
	const lowerCasedQuery = query.toLowerCase();
	const filteredCountries = countries.filter((country) => country.name.toLowerCase().includes(lowerCasedQuery));
	filteredCountries.sort((a, b) => a.name.localeCompare(b.name));
	return filteredCountries;
}

function mapStateToProps(
	{ aeMaxPrice }: { aeMaxPrice: AeMaxPriceState },
	{ value }: { value: string }
): Record<never, never> {
	return {
		options: mapOptions(aeMaxPrice.nationalities?.items || [], value),
	};
}

const actions = {
	onFetch: loadNationalities,
};

export default connect(mapStateToProps, actions)(Autocomplete);
